import { GrowthBook, configureCache } from '@growthbook/growthbook-react';
import { Flags } from '../shared';
import {
  FeatureFlagCacheOptions,
  FeatureFlagClientConfig,
} from './feature-flag.types';

export class FeatureFlagClient extends GrowthBook<Flags> {
  constructor({
    config,
    devMode = false,
  }: {
    config: FeatureFlagClientConfig;
    devMode?: boolean;
  }) {
    super({
      debug: devMode,
      enableDevMode: devMode,
      onFeatureUsage: (featureKey, result) => {
        if (devMode) {
          console.log(
            '[Feature Flag]',
            'feature:',
            featureKey,
            'has value:',
            result.value,
          );
        }
      },
      ...config,
    });
  }
}

/**
 * @param settings - Settings for the feature flag cache.
 * There are a number of cache settings you can configure.
 * This must be done BEFORE creating a Feature Flag instance.
 */
export const initFeatureFlagCache = (settings?: FeatureFlagCacheOptions) => {
  const defaultSettings: FeatureFlagCacheOptions = {
    // The localStorage key the cache will be stored under
    cacheKey: 'ffCache',
    // Consider features stale after this much time (5 minutes)
    staleTTL: 1000 * 60 * 5,
    // Cached features older than this will be ignored (24 hours)
    maxAge: 1000 * 60 * 60 * 24,
    // For Remote Eval only - limit the number of cache entries (~1 entry per user)
    maxEntries: 5,
    // Disable SSE when the page is idle since we don't use streaming
    disableIdleStreams: true,
    // Consider a page "idle" when it is hidden for this long (30 seconds)
    idleStreamInterval: 30000,
    // Set to `true` to completely disable both in-memory and persistent caching
    disableCache: false,
  };

  configureCache({
    ...defaultSettings,
    ...settings,
  });
};
